import { Box } from '@chakra-ui/react';
import { IOption } from '../../../../../../../interfaces';
import VariantList from '../variantList/variantList';

interface Props {
    option: IOption;
}

export default function OptionItem({ option }: Props) {
    const variants = option.variants;
    return (
        <Box>
            <VariantList variants={variants} title={option.name} type={option.type} />
        </Box>
    );
}
